<script>
import { VCheckbox } from 'vuetify/lib'
import { getSlot } from 'vuetify/lib/util/helpers'
import { prevent } from 'vuetify/lib/mixins/selectable/index'
import SVGCheckmark from './SVGCheckmark'

export default {
  name: 'ECheckbox',
  extends: VCheckbox,
  props: {
    dense: { type: Boolean, default: true },
    ripple: { type: Boolean, default: false },
    detail: { type: String, default: '' },
    hideDetails: { type: [Boolean, String], default: 'auto' },
  },
  computed: {
    classes() {
      return {
        'e-checkbox': true,
        ...VCheckbox.options.computed.classes.call(this),
      }
    },
  },
  methods: {
    genCheckboxContent() {
      return this.$createElement(
        'div',
        {
          staticClass: 'e-checkbox__content',
        },
        [this.genLabel(), this.genDetail()]
      )
    },
    genLabel() {
      if (!this.label) return null
      return this.$createElement(
        'label',
        {
          on: {
            // Label shouldn't cause the input to focus
            click: prevent,
          },
          attrs: {
            for: this.computedId,
          },
          staticClass: 'e-checkbox__label',
        },
        this.label
      )
    },
    genDetail() {
      if (!this.detail) return null
      return this.$createElement(
        'span',
        {
          staticClass: 'e-checkbox__detail',
        },
        getSlot(this, 'detail') || this.detail
      )
    },
    genCheckmark() {
      if (this.indeterminate || this.isActive) {
        return this.$createElement(SVGCheckmark, {
          props: {
            checked: this.isActive,
            indeterminate: this.inputIndeterminate,
          },
        })
      }
      return null
    },
    genCheckbox() {
      const { title, ...checkboxAttrs } = this.attrs$
      return this.$createElement(
        'div',
        {
          staticClass: 'v-input--selection-controls__input',
        },
        [
          this.$createElement(
            'div',
            {
              staticClass: 'e-checkbox__checkmark',
              class: (this.isActive || this.inputIndeterminate) && 'e-checkbox__checkmark--checked',
            },
            [this.genCheckmark()]
          ),
          this.genInput('checkbox', {
            ...checkboxAttrs,
            'aria-checked': this.inputIndeterminate ? 'mixed' : this.isActive.toString(),
          }),
        ]
      )
    },
    genDefaultSlot() {
      return [this.genCheckbox(), this.label || this.detail ? this.genCheckboxContent() : null]
    },
  },
}
</script>
